import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  showHeader = false;
  showHeaderSpinea = false;
  showFooter = false;
  showFooterSpinea = false;

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event) => {
      
      const currentUrl = window.location.href.toLowerCase();
      console.log('Current URL:', currentUrl); // Debugging log
      if (currentUrl.includes('spineatools') ) {
        this.showHeader = false;
        this.showHeaderSpinea = true;
        this.showFooter = false;
        this.showFooterSpinea = true;
      } else {
        this.showHeader = true;
        this.showHeaderSpinea = false;
        this.showFooter = true;
        this.showFooterSpinea = false;
      }
    });
  }
}